import { createService } from './config/axios';
import {
  TMypagePasswordCheckParams,
  TMypageInfoResponse,
  TDupCheckEmailParams,
  TDupCheckPhoneNumParams,
  TEditMypageInfoParams,
} from 'types/apis/mypage';

export const postMypagePasswordCheck = async (
  data: TMypagePasswordCheckParams
) => {
  await createService({
    url: '/all-user/mypage/password-check',
    options: {
      method: 'post',
      data,
    },
  });
};

export const getStudentMypageInfo = async () =>
  await createService<TMypageInfoResponse>({
    url: '/student-mypage',
    options: {
      method: 'get',
    },
  });

export const putStudentMypageInfo = async (data: TEditMypageInfoParams) =>
  await createService({
    url: '/student-mypage',
    options: {
      method: 'put',
      data,
    },
  });

export const getProfessorMypageInfo = async () =>
  await createService<TMypageInfoResponse>({
    url: '/professor-mypage',
    options: {
      method: 'get',
    },
  });

export const putProfessorMypageInfo = async (data: TEditMypageInfoParams) =>
  await createService({
    url: '/professor-mypage',
    options: {
      method: 'put',
      data,
    },
  });

export const postDupCheckEmail = async (data: TDupCheckEmailParams) =>
  await createService({
    url: '/dup-check-email',
    options: {
      method: 'post',
      data,
    },
  });

export const postDupCheckPhoneNum = async (data: TDupCheckPhoneNumParams) =>
  await createService({
    url: '/dup-check-phoneNum',
    options: {
      method: 'post',
      data,
    },
  });
